import React, { useEffect, useState } from "react";
import DashboardLayout from "../../../layouts/DashboardLayout/DashboardLayout";
import { Box, Typography,Divider } from "@mui/material";
import typographyStyles from "../../../theme/Typography";
import BasicButtons from "../../../components/Button";
import InputField from "../../../components/InputField";
import { useNavigate, useParams } from "react-router-dom";
import { useFormik } from "formik";
import { addNewCategorySchema } from "../../../schema";
import "../../../scss/main.css";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import {
	ClassicEditor,
	AccessibilityHelp,
	Alignment,
	Autoformat,
	AutoLink,
	Autosave,
	BlockQuote,
	Bold,
	CodeBlock,
	Essentials,
	FontBackgroundColor,
	FontColor,
	FontFamily,
	FontSize,
	GeneralHtmlSupport,
	Heading,
	HorizontalLine,
	Indent,
	IndentBlock,
	Italic,
	Link,
	Paragraph,
	SelectAll,
	Style,
	Table,
	TableCaption,
	TableCellProperties,
	TableColumnResize,
	TableProperties,
	TableToolbar,
	TextTransformation,
	Underline,
	Undo
} from 'ckeditor5';
import {
  getDataHandlerWithToken,
  postDataHandler,
  postDataHandlerWithToken,
} from "../../../apiconfig/service";
import toast from "react-hot-toast";
import backBtn from "../../../assets/backBtn.svg";


const addEditStyle = {
  addEditTitle: {
    ...typographyStyles.h4,
  },
  addEditLabel: {
    ...typographyStyles.h6,
  },
  radioContainer: {
    display: "flex",
  },
};

const EditExercise = () => {
  const [thumbnail, setThumbnail] = useState(null);
  const [editorContent, setEditorContent] = useState("");
  const navigate = useNavigate();
  const { exerciseId } = useParams();
  const [loading, setLoading] = useState(false);

  const handleThumbnailChange = (event) => {
    const file = event.target.files[0];
    setThumbnail(file);
    formik.setFieldValue("categoryImage", file);
  };

  const initialValues = {
    exerciseName: "",
    categoryImage: null,
    description: "",
  };

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: addNewCategorySchema,
    onSubmit: async (values) => {
      values.description = editorContent; // Set the editor content to formik values
      try {
        setLoading(true)
        const formData = new FormData();
        formData.append("file", values.categoryImage);
        const result = await postDataHandler("uploadFile", formData);
        const res = await postDataHandlerWithToken("addUpdateExercise", {
          exerciseId: exerciseId,
          exerciseName: values.exerciseName,
          description: values.description,
          image: [result.result],
        });
        // Handle response if needed
        if (res.responseCode === 200) {
          toast.success(res.responseMessage);
          console.log(res);
          navigate(-1);
        } else {
          // Handle errors
          toast.error(res.data.responseMessage);
          console.error(res);
        }
      } catch (error) {
        console.error("Error while updating exercise :", error);
      }finally{
        setLoading(false)
      }
    },
  });

  const {
    values,
    errors,
    handleBlur,
    handleChange,
    touched,
    handleSubmit,
    setValues,
  } = formik;

  useEffect(() => {
    const fetchExercise = async () => {
      try {
        const result = await getDataHandlerWithToken("viewExercise", {
          exerciseId,
        });
        if (result.responseCode === 200) {
          toast.success(result.responseMessage);
          const exerciseData = result.result;
          setValues({
            exerciseName: exerciseData.exerciseName,
            categoryImage: exerciseData.image,
            description: exerciseData.description,
          });
          setEditorContent(exerciseData.description); // Set the editor content
        } else {
          toast.error(result.responseMessage);
        }
      } catch (error) {
        console.log(error);
      }
    };

    fetchExercise();
  }, [exerciseId, setValues]);

  return (
    <DashboardLayout
      sectionName="Workout Management - Category - Exercise"
      title="Edit Exercise"
      showBackButtonSection={true}
    >
         <Box className="heading-container-top">
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap:"10px"
          }}
        >
           <Box>
            <img
              src={backBtn}
              alt="backBtn"
              style={{
                // // width: "2.813",
                // height: "5.813",
                cursor: "pointer",
              }}
              onClick={() => navigate(-1)}
            />
          </Box>
          <Typography sx={{ ...typographyStyles.h4 }}>
        Edit Exercise
          </Typography>

         
        </Box>
      </Box>
      <Divider />
      <Box className="add-edit-container">
        <form className="add-edit-content-section" onSubmit={handleSubmit}>
          <Box className="add-edit-content">
            <Box className="add-edit-input-container">
              <Box className="add-edit-input-label">
                <Typography sx={addEditStyle.addEditLabel}>
                  Exercise Name:
                </Typography>
              </Box>
              <Box className="add-edit-input-field">
                <InputField
                  type="text"
                  name="exerciseName"
                  value={values.exerciseName}
                  maxLength={30}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder="Enter exercise name"
                />
                {errors.exerciseName && touched.exerciseName ? (
                  <p style={{ color: "red", marginTop: "2px", float: "left" }}>
                    {errors.exerciseName}
                  </p>
                ) : null}
              </Box>
            </Box>
            <Box className="add-edit-input-container">
              <Box className="add-edit-input-label">
                <Typography sx={addEditStyle.addEditLabel}>
                  Exercise Thumbnail Image:
                </Typography>
              </Box>
              <Box className="add-edit-input-field">
                <InputField
                  type="file"
                  name="categoryImage"
                  onBlur={handleBlur}
                  onChange={handleThumbnailChange}
                  inputProps={{ accept: "image/*" }}
                />
                {errors.categoryImage && touched.categoryImage ? (
                  <p style={{ color: "red", marginTop: "2px", float: "left" }}>
                    {errors.categoryImage}
                  </p>
                ) : null}
              </Box>
            </Box>
            <Box className="add-edit-input-container desc-box">
              <Box className="add-edit-input-label">
                <Typography sx={addEditStyle.addEditLabel}>
                  Description:
                </Typography>
              </Box>
              <Box className="add-edit-input-field">
                <CKEditor
                  editor={ClassicEditor}
                  data={editorContent}
                  onChange={(event, editor) => {
                    const data = editor.getData();
                    setEditorContent(data);
                  }}
                  config={{
                    toolbar: [
                      "heading",
                      "|",
                      "bold",
                      "italic",
                      "underline",
                      "strikethrough",
                      "|",
                      "bulletedList",
                      "numberedList",
                      "blockQuote",
                      "|",
                      "link",
                      "imageUpload",
                      "insertTable",
                      "mediaEmbed",
                      "|",
                      "undo",
                      "redo",
                    ],
                    height: "400px",
                  }}
                  className="StaticEditor"
                />
              </Box>
            </Box>
          </Box>
          <Box className="add-edit-button-section" sx={{ alignItems: "center", justifyContent: "center" }}>
            <BasicButtons text={"Update Exercise" } disabled={loading} name="submit" type="submit" loading={loading} width={"20%"}/>
            {/* <BasicButtons
              text="Back"
              width={"25%"}
              onClick={() => {
                navigate("/workoutlisting");
              }}
            /> */}
          </Box>
        </form>
      </Box>
    </DashboardLayout>
  );
};

export default EditExercise;
